<mat-selection-list  (selectionChange)="selectionChanged($event)"  [multiple]="false" #areaList>
  <mat-list-option [value]="area" *ngFor="let area of areas">
    {{area.city}}, {{area.county}} {{area.country}}
  </mat-list-option>
</mat-selection-list>
